export default __webpack_public_path__ + "static/media/Boots of Violent Rage.c270b603.jpg";